import { Injectable } from '@angular/core';
import { catchError, Observable, of, shareReplay } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ExpansionJointFocus, PackerSchematicDisplayMode, Packers } from '../models/packers.model';

export interface GetPackerSchematicRequest {
  tubularId?: string;
  packerIndex: number;
  mode: PackerSchematicDisplayMode;
  subTitle?: string;
  width?: number;
  height?: number;
  loadCaseIndex?: number;
  expansionJointFocus: ExpansionJointFocus;
}

const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api`
@Injectable({
  providedIn: 'root'
})
export class PackerService {
  private packersCache$: Record<string, Observable<Packers>> = {};

  constructor(private http: HttpClient) { }

  public getPackersForTubular(tubularId?: string | null): Observable<Packers> {
    const cacheKey = tubularId || 'no_tubular_id';
    if (!this.packersCache$[cacheKey]) {
      this.packersCache$[cacheKey] = this.http
        .get<Packers>(`${PeriforApiEndpoint}/packers`, { params: tubularId ? { tubularId } : {} })
        .pipe(
          catchError(() => of(null as Packers)),
          shareReplay(1)
        );
    }
    setTimeout(() => this.packersCache$[cacheKey] = null, 1000);
    return this.packersCache$[cacheKey];
  }

  updatePackers(packer: any): Observable<boolean> {
    return this.http.put<boolean>(`${PeriforApiEndpoint}/packers`, packer);
  }

  public getPackerSchematic(
    packerIndex: number,
    mode: PackerSchematicDisplayMode = PackerSchematicDisplayMode.CrossSectionalAreas,
    tubularId?: string,
    subTitle?: string,
    width?: number,
    height?: number,
    loadCaseIndex?: number,
    expansionJointFocus: ExpansionJointFocus = ExpansionJointFocus.ExpansionJoint
  ): Observable<string> {
    const request: GetPackerSchematicRequest = {
      packerIndex,
      mode,
      tubularId,
      subTitle,
      width,
      height,
      loadCaseIndex,
      expansionJointFocus
    };
    
    return this.http.post(`${PeriforApiEndpoint}/packers/schematic`, request, {
      headers: { 'Accept': 'image/svg+xml' },
      responseType: 'text'
    });
  }

}
